import styled, { css } from 'styled-components';
import PasswordShow from '../../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-password-show.svg'
import PasswordHide from '../../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-password-hide.svg'
import { colour , spacing, media, visibility, typography,TextParagraph } from '../../../theme';
import colors from '../../../theme/variables/colors';

export const StepIndicatorContainer = styled.div`
  width: 100%;
  margin-bottom: 2.5rem;
`;

export const StepIndicatorBtnContainer = styled.div<{
  withbackbtn: true | false;
}>`
  ${(props) =>
    props.withbackbtn === true &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;

      // Galaxy fold
      @media screen and (max-width: 293px) {
        flex-direction: column;
      }
    `};

  ${(props) =>
    props.withbackbtn === false &&
    css`
      display: flex;
      justify-content: flex-end;
      align-items: center;
    `};
`;

export const StepIndicatorSpan = styled.span`
  margin: 1.125rem 0;
  font-size: 1.25rem;
  letter-spacing: 0.0313rem;
  line-height: 1.5;
  font-weight: 700;
  font-family: 'Raleway', 'Open Sans', 'Helvetica Neue', Helvetica, Arial,
    sans-serif;

  @media ${media.small} {
    margin: 1rem 0;
    font-size: 1.5rem;
    letter-spacing: 0.03rem;
    line-height: 1.5;
  }
`;

export const HorizontalRule = styled.hr`
  padding: 0;
  margin: 0;
  border-style: none;
  border-bottom: 4px solid ${colour.hrBorder};
`;

export const VisuallyHiddenText = styled.span`
  border: none;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
export const StyledNumberShow = styled(PasswordShow)`
    margin-right: ${spacing.spacing2};
    path {
        fill: ${colors.darkBtnBG};
    }
`;
export const StyledNumberHide = styled(PasswordHide)`
    margin-right: ${spacing.spacing2};
    path {
        fill: ${colors.darkBtnBG};
    }
`;

export const StyledTextParagraph = styled(TextParagraph)`
    margin-top: ${spacing.spacing5};
    @media ${media.small} {
        margin-top: ${spacing.spacing7};
    }
`;